import styled from 'styled-components';

import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

const Container = styled(FlexBoxColumn)`
  background-color: ${(props) => props.theme.color.background.basic};
  align-items: flex-start;
  padding-left : 20px;
  width: 100%;
  height: 220px;  
`;

const InfoTextBox = styled(TextBox)`
  font-size: ${({ size }) => size || moTheme.font.size.$12};
  line-height: ${moTheme.font.lineHeight.demiLight};
  font-weight: ${({ weight }) => weight || moTheme.font.weight.demiLight};
  border-bottom: ${({ isEmphasize, theme }) => (isEmphasize ? `1px solid ${theme.color.line.selected}` : '')};
`;

const TextBold = styled.span`
  font-weight: 500;
  padding-right: 8px;
`;

const SkypassFooterSubNoticeContainer = styled(FlexBoxColumn)`
  align-items: flex-start;
  height: 126px;
`;


export { Container, InfoTextBox, TextBold,SkypassFooterSubNoticeContainer };
